var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm.variant,"disabled":_vm.opened},on:{"click":_vm.plaid}},[_vm._v(_vm._s(_vm.buttonTitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }